
























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbAlert, mdbCard, mdbCardBody, mdbCardTitle, mdbBtn, mdbCol, mdbIcon, mdbInput, mdbRow, mdbTooltip, mdbPopover, mdbListGroup, mdbListGroupItem } from '@folky-tools/mdbvue';
import { businessFrontPagesService, notificationsService, usersService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { Business } from '@/models/businesses/business';

@Component({
    components: {
        mdbAlert,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbBtn,
        mdbCol,
        mdbIcon,
        mdbInput,
        mdbRow,
        mdbTooltip,
        mdbPopover,
        mdbListGroup,
        mdbListGroupItem,
        EditFrontPageSlug: () => import('@/components/shared/EditSlug.vue'),
        FormModal: () => import('@/components/shared/FormModal.vue')
    }
})
export default class SlugSummaryCard extends Vue {
    @Prop(BusinessFrontPage) private frontPage!: BusinessFrontPage;
    @Prop(Business) private business!: Business;
    private contentLoaded: boolean = false;
    private modalIsVisible: boolean = false;

    private mounted(): void {
        setTimeout(() => this.switchContentToLoaded(), 1000);
    }

    private switchContentToLoaded() {
        this.contentLoaded = true;
    }

    private async save(): Promise<void> {
        try {
            if (await businessFrontPagesService.checkIfBusinessFrontPageSlugExists(this.frontPage.businessId, this.frontPage.slug!)) {
                notificationsService.showToastErrorNotification('components.shared.slugSummaryCard.notifications.slugExists');
            } else {
                await businessFrontPagesService.updateBusinessFrontPageSlug(this.frontPage.businessId, this.frontPage.slug!);

                notificationsService.showToastSuccessNotification('components.shared.slugSummaryCard.notifications.slugUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.Slug,
                        entityId: this.frontPage.businessId
                    })
                );
            }
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.closeModal();
        }
    }

    private async closeModal(): Promise<void> {
        this.$emit('modal-closed');
        this.modalIsVisible = false;
    }

    private newSlugHasErrors(): boolean {
        const editSlugElement: any = this.$refs.editSlug;

        if (editSlugElement.hasErrors()) {
            return true;
        }

        return false;
    }

    private async copyToClipboard(text: string): Promise<void> {
        await navigator.clipboard.writeText(text);
        notificationsService.showToastSuccessNotification('components.shared.slugSummaryCard.notifications.urlCopiedSuccess');
    }

    get availableConsumers(): any[] {
        const result: any[] = [];

        let slugOrPlaceholder = this.$t('components.shared.slugSummaryCard.noSlugDefinedPlaceholder').toString();
        if (this.frontPage.slug!) {
            slugOrPlaceholder = this.frontPage.slug!;
        }

        this.frontPage.publicationStatus.forEach(ps => {
            const consumerDetails = this.business.consumersAvailable.find(ca => ca.consumerId === ps.consumerId);
            if (consumerDetails && !(consumerDetails.organizationId === 1 && consumerDetails.consumerId === 1)) {
                const linkToConsumerFrontPage = consumerDetails.urlParts.find(up => up.culture === this.$i18n.locale);

                result.push({
                    id: ps.consumerId,
                    urlPart1: `${linkToConsumerFrontPage!.url}/`,
                    urlPart2: `${slugOrPlaceholder}`,
                    isPublished: ps.isPublished,
                    isCanonical: ps.isCanonical
                });
            }
        });

        const canonicalFirst = result.sort((x, y) => {
            return x.isCanonical === y.isCanonical ? 0 : x ? -1 : 1;
        });

        return canonicalFirst;
    }
}
